import {requestActions, API_REQUEST_ACTION} from "../models/requests";
import {httpAction} from "./httpMiddleware";
import {normalize} from "normalizr";

export default function ({ baseUrl }) {
    return ({ dispatch, getState }) => next => action => {
        const state = getState(); //eslint-disable-line
        const { type, key, types, schema, form, extra = {}, ...requestParams } = action; // TODO: check if form is ever used
        if (type === API_REQUEST_ACTION) {
            const httpRequest = makeHttpAction(baseUrl, requestParams);
            if (types) { // action was created by apiAction action creator
                // dispatch started/http/succeeded/failed actions
                const actions = requestActions(key, types, requestParams, extra);

                dispatch(actions.started());
                return next(httpRequest)
                    .then(response => {
                        if (schema) {
                            const normalized = normalize(response, schema);
                            return dispatch(actions.succeeded({ response: normalized.result }));
                        } else {
                            return dispatch(actions.succeeded({ response: response }));
                        }
                    }).catch(error => {
                        dispatch(actions.failed({ error }));
                        if (form && error.body) { // if using api request as a form submission, format result to be consumable for redux-form
                            return Promise.reject({ _error: error.body.error, ...error.body.errors }); //eslint-disable-line
                        } else {
                            return Promise.reject(error); //eslint-disable-line
                        }
                    });
            } else {
                // dispatch just http action
                return dispatch(httpRequest);
            }
        } else {
            return next(action);
        }
    };
}

export function makeHttpAction (baseUrl, { method, path, query, body, redirect, mode }) {
    var request = {
        url: baseUrl + path,
        method: method || "GET",
        redirect: redirect,
        mode: mode,
	credentials: "same-origin",
        headers:   makeHeaders() // userInfo.token ? makeHeadersWithToken() :  makeHeaders()
    };
    let methodBody = body;
    methodBody.token = window.localStorage.getItem("user_info") && JSON.parse(window.localStorage.getItem("user_info")).token; 
    methodBody.username = window.localStorage.getItem("user_info") && JSON.parse(window.localStorage.getItem("user_info")).username;
    const withQuery = query ? { ...request, query } : request;
    const withBody = body ? { ...withQuery, body: JSON.stringify(methodBody) } : withQuery;
    return httpAction(withBody);
}

function makeHeaders () {
    return {
        "Accept": "application/json",
        "Content-Type": "application/json"
    };
}
